import { siteEventNames } from '../events/site-events';
import { getAllSelectedSwatches } from './swatchbook-utils';

export default () => {
  const render = (ct) => {
    const navItemSelectors = '.main-nav-list .primary-item-free-swatches, .free-swatches-item .nav-link';
    const indicatorSelector = 'swatch-count items-added-to-swatches';
    const navItemDivs = document.querySelectorAll(navItemSelectors);
    [].map.call(navItemDivs, (navItem) => {
      const indicatorDiv = navItem.querySelector('.swatch-count');
      if (ct === 0 && indicatorDiv) {
        indicatorDiv.remove();
      } else if (ct > 0 && indicatorDiv) {
        indicatorDiv.textContent = ct;
      } else if (ct > 0 && indicatorDiv === null) {
        const span = document.createElement('span');
        span.classList = indicatorSelector;
        span.textContent = ct;
        navItem.appendChild(span);
      }
    });
  };

  const update = () => {
    getAllSelectedSwatches()
      .then((data) => {
        const ct = data.length;
        render(ct);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  window.addEventListener(siteEventNames.ADD_SWATCH, update);
  window.addEventListener(siteEventNames.REMOVE_SWATCH, update);
  update();
};
